/**
 * Sprint BG Part 2 — GA4 stub (apps/admin)。
 *
 * apps/user 版と同設計。Measurement ID が空なら silent no-op。
 * admin の analytics は別 ID を別 .env で渡す想定 (運用上 user / admin の event 流を分離)。
 */

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const MEASUREMENT_ID: string = import.meta.env.VITE_GA4_MEASUREMENT_ID ?? '';

let initialized = false;

export function initGa4(): void {
  if (initialized) return;
  if (!MEASUREMENT_ID) {
    // eslint-disable-next-line no-console
    console.info(
      '[GA4] Measurement ID 未設定のためスキップ (VITE_GA4_MEASUREMENT_ID を .env.local に設定すると有効化)。',
    );
    return;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  window.dataLayer = window.dataLayer ?? [];
  window.gtag = function gtag(...args: unknown[]): void {
    window.dataLayer!.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID, {
    anonymize_ip: true,
    cookie_flags: 'SameSite=None;Secure',
    send_page_view: false,
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(MEASUREMENT_ID)}`;
  document.head.appendChild(script);

  initialized = true;
  // eslint-disable-next-line no-console
  console.info('[GA4] initialized', { measurementId: MEASUREMENT_ID });
}

export function trackPageView(path: string): void {
  if (!initialized || !window.gtag) return;
  window.gtag('event', 'page_view', { page_path: path });
}

export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (!initialized || !window.gtag) return;
  window.gtag('event', name, params ?? {});
}
